var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2To3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "41px",
    viewBox: "0 0 214 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp-|-Signup-FInal--(Desktop)",
    transform: "translate(-277.000000, -644.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277,674.393144 C366,719.402954 425.644531,581.476884 493.5,682.738603",
    id: "Path-5",
    transform: "translate(385.250000, 664.196572) scale(1, -1) translate(-385.250000, -664.196572) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2To3);
export default __webpack_public_path__ + "static/media/step-2-to-3.4c95231eacc30e1f5523fe666fb0322a.svg";
export { ForwardRef as ReactComponent };